import { DropdownDivider, DropdownItem } from 'flowbite-react';
import { Link, UIMatch, useMatches } from 'react-router';
import { useTranslation } from 'react-i18next';
import { RouteHandle } from 'types/ReactRouter';
import { IconExternalLink } from '@tabler/icons-react';

const AboutThisPageLink = ({ dropdown = false }: { dropdown?: boolean }) => {
    const { t } = useTranslation('layout');
    const routeMatches = useMatches() as UIMatch<unknown, RouteHandle>[];
    const helpUrlMatch = routeMatches.filter((match) => match.handle?.helpUrl);
    const helpUrl = helpUrlMatch.at(-1)?.handle.helpUrl;

    if (!helpUrl) {
        return null;
    }

    if (dropdown) {
        return (
            <>
                <DropdownItem
                    as="a"
                    rel="noopener noreferrer"
                    target="_blank"
                    href={helpUrl}
                >
                    {t('help-menu.about-this-page')}
                    <IconExternalLink size={20} />
                </DropdownItem>
                <DropdownDivider />
            </>
        );
    }
    return (
        <Link
            to={helpUrl}
            className="flex gap-2 items-center group"
            target="_blank"
        >
            <span className="font-medium text-base leading-6 text-primary group-hover:text-primary-700 flex gap-2 items-center">
                {t('help-menu.about-this-page')}
                <IconExternalLink size={20} />
            </span>
        </Link>
    );
};

export default AboutThisPageLink;
